module.exports = __webpack_public_path__ + "img/dne-token.d0a388b8.jpg";